import React, { useState } from 'react';
import { Group, SegmentedControl } from '@mantine/core';

import type { MasterEntityType } from '@api/entity-attributes';
import EntityMasterTab from './EntityMasterTab';

/**
 * The five things a merchant HAS, as against the relationships between them — those live
 * in Vendor Mapping. Vendors moved here from that section: a vendor is an entity like a
 * product or a warehouse, and its own grid (payment terms, the Add vendor form) has
 * nothing to do with what it happens to supply.
 */
const TABS: { value: MasterEntityType; label: string }[] = [
    { value: 'PRODUCT', label: 'Products' },
    { value: 'WAREHOUSE', label: 'Warehouses' },
    { value: 'CHANNEL', label: 'Channels' },
    { value: 'MATERIAL', label: 'Materials' },
    { value: 'VENDOR', label: 'Vendors' },
];

const EntityMasterSection: React.FC = () => {
    const [active, setActive] = useState<MasterEntityType>('PRODUCT');

    return (
        <>
            <Group mb="md">
                <SegmentedControl
                    value={active}
                    onChange={(v) => setActive(v as MasterEntityType)}
                    data={TABS}
                    size="xs"
                />
            </Group>
            <EntityMasterTab key={active} entityType={active} />
        </>
    );
};

export default EntityMasterSection;
